const ScreenTypes = {
        "PASSENGER_DETAILS" : "PASSENGER_DETAILS",
        "BAGGAGE" : "BAGGAGE",
        "SEATS" : "SEATS",
        "PAYMENT" : "PAYMENT",
        "IFRAME" : "IFRAME",
        "CONFIRMATION" : "CONFIRMATION"
}

export default ScreenTypes;